export const messages = {
    "shared-link.footer.link.install": "{brandName}を無料でお試しください",
    "shared-link.footer.link.mobile": "モバイル向けの{brandName}",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "保護されたデータ",
    "shared-link.password-dialog-box.message": "共有データにアクセスするためのパスワードを指定してください",
    "shared-link.password-dialog-box.hint.password": "パスワード",
    "shared-link.password-dialog-box.message.invalid-password": "パスワードが正しくありません",
    "shared-link.form.button.open": "開く",
    "shared-link.page-not-found.title": "ページが見つかりません",
    "shared-link.page-not-found.message.main": "お探しのページが見つかりませんでした。",
    "shared-link.page-not-found.message.description": "リンクが古いか、アドレスが正しく入力されなかった可能性があります。",
    "shared-link.page-not-found.message.error": "エラー コード:404",
    "shared-link.restore-file.label.size": "サイズ",
    "shared-link.restore-file.button.restore": "ダウンロード",
    "shared-link.links-table.column.name": "名前",
    "shared-link.links-table.column.size": "サイズ",
    "shared-link.links-table.action.restore": "ダウンロード",
    "shared-link.links-table.action.restore-all": "すべてダウンロード",
    "shared-link.side-bar.selected.title:plural": "{count}アイテム選択済み | {count}アイテム選択済み",
    "shared-link.links-table.label.size": "サイズ",
    "shared-link.links-table.message.empty-folder": "このフォルダは空です"
};
